export default {"src":"/_next/static/media/carOutline_64.28bd8c16.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};